import {get} from '../utils'

export default host => (channelId) =>
  get(`${host}/channels/${channelId}/user/recentSearch`)
    .then(response => response.json())
    .then(json => json.data)

